import { washArabic, washHeadData } from '@/utils/wash.js'
const washData = (node) => {
  try {
    washHeadData(node, 'logo', 'name', true)
    washHeadData(node, 1, '_contentType')
    washHeadData(node, 3, '_contentType')
    switch (node._type) {
      case 'head_style_ten':
        washHeadData(node, 'head-title')
        washHeadData(node, 'home-product-title')
        break
      case 'head_style_eleven':
        washHeadData(node, 'head-title')
        washHeadData(node, 'mid-row')
        washHeadData(node, 'eleven-logo')
        washHeadData(node, 'eleven-logo', undefined,true)
        break
      case 'head_style_seven':
        washHeadData(node, 'card', 'componentName')
        break
      case 'head_style_eight':
        washHeadData(node, 'card', 'componentName')
        washHeadData(node, 'search')
        washHeadData(node, 'e-Nav')
        break
      case 'head_style_nine':
        washHeadData(node, 'rowCol', 'componentName')
        break
      case 'head_style_thirteen':
        washHeadData(node, 'logoT', 'componentName')
        break
    }
    washHeadData(node, node._type, 'rNav')
    washHeadData(node, node._type, 'rowColFlag', true)
    washHeadData(node, 'language_flagNameSelect', 'componentName')
    washHeadData(node, 'language_flagNameSelect', 'componentName', true)
    washArabic(node)
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
